import { gen2Request } from 'src/services/gen_2_http_reqs';
import type { SettingRequest } from 'src/types/requests/settings/setting';
import { onSettingsResponse } from '../device_settings_helpers';
import type { Device } from 'src/types/Device';

// Define the BLEControl interface
export interface BtHomeControlInterface {
	list(device: Device, id?: number): Promise<SettingRequest>;
	enumerate(device: Device): Promise<SettingRequest>;
	stopLearning(device: Device): Promise<SettingRequest>;
	startLearning(device: Device, params: {}): Promise<SettingRequest>;
	deleteAll(device: Device, id): Promise<SettingRequest>;
	create(device: Device, params: {}): Promise<SettingRequest>;
	getInstance(): BtHomeControlInterface;
}

// Define the BtHomeControl class
export class BtHomeController implements BtHomeControlInterface {
	private static instance: BtHomeController | null = null;

	// Private constructor to prevent direct instantiation
	private constructor() {}
	getInstance(): BtHomeControlInterface {
		// throw new Error("Method not implemented.");
		return BtHomeController.getInstance();
	}

	// Singleton pattern implementation
	static getInstance(): BtHomeControlInterface {
		if (!this.instance) {
			this.instance = new BtHomeController();
		}
		return this.instance;
	}

	// Implement the BLEControl methods
	public async list(device: Device, id?: number): Promise<SettingRequest> {
		const params = id !== undefined ? { id } : {};
		return await this.controlBleDevice(device, 'List', params);
	}

	public async enumerate(device: Device): Promise<SettingRequest> {
		return await this.controlBleDevice(device, 'Enumerate');
	}

	public async deleteAll(device: Device, id): Promise<SettingRequest> {
		console.warn('[BT HOME] deleteAll', id);
		return await this.controlBleDevice(device, 'DeleteAll', { id });
	}

	public async startLearning(device: Device, params): Promise<SettingRequest> {
		return await this.controlBleDevice(device, 'StartLearning', { ...params });
	}

	public async create(device: Device, params): Promise<SettingRequest> {
		return await this.controlBleDevice(device, 'Create', { ...params });
	}

	public async stopLearning(device: Device): Promise<SettingRequest> {
		return await this.controlBleDevice(device, 'StopLearning');
	}

	// Private method to control BLE devices
	private async controlBleDevice(
		device: Device,
		method: string,
		params?: {},
	): Promise<SettingRequest> {
		if (!device.id) {
			return { isok: false } as SettingRequest;
		}

		try {
			const res: SettingRequest = await gen2Request(device, 'BTHomeControl.' + method, {
				...params,
			});

			if (res?.errors) {
				onSettingsResponse(res, device);
			}

			return res;
		} catch (error) {
			// Handle the error or rethrow it
			throw error;
		}
	}
}
